function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable new-cap */
import { getStyleFunction, useStyleFunction, wrapClusterStyleFunction, geometryTypeToStyleType } from 'oskari-frontend/bundles/mapping/mapmodule/oskariStyle/generator.ol';
var defaults = {
  style: {
    fill: {
      color: '#FAEBD7'
    },
    stroke: {
      color: '#000000',
      width: 1,
      area: {
        color: '#000000',
        width: 1
      }
    },
    image: {
      shape: 5,
      size: 3,
      fill: {
        color: '#FAEBD7'
      }
    }
  },
  hover: {
    inherit: true,
    effect: 'auto minor'
  }
};
export var DEFAULT_STYLES = _objectSpread({}, defaults);
var isClusteredLayer = function isClusteredLayer(mapmodule, layer) {
  // mvt rendering isn't supported in 3D, no need to check layer's render mode
  // TODO: should we check for -1 or undefined type? Seems it defaults to -1 and not 'undefined'
  return !mapmodule.getSupports3D() && layer.getClusteringDistance() !== -1 && typeof layer.getClusteringDistance() !== 'undefined';
};
var defaultStyleGenerator = function defaultStyleGenerator(mapmodule, layer) {
  return useStyleFunction(layer) ? getDefaultStyleFunction(mapmodule, layer) : getTypedStyle(mapmodule, layer);
};
var defaultTypedStyles = {}; // cached default ol styles for point, line and area
var getTypedStyle = function getTypedStyle(mapmodule, layer) {
  var geometryType = layer.getGeometryType();
  var styleType = geometryTypeToStyleType(geometryType);
  var style = defaultTypedStyles[styleType];
  if (!style) {
    style = mapmodule.getStyle(DEFAULT_STYLES.style, styleType);
    defaultTypedStyles[styleType] = style;
  }
  return style;
};
var defaultStyleFunction;
var clusteredFunction;
var getDefaultStyleFunction = function getDefaultStyleFunction(mapmodule, layer) {
  var isClustered = isClusteredLayer(mapmodule, layer);
  if (!isClustered && defaultStyleFunction) {
    return defaultStyleFunction;
  }
  if (isClustered && clusteredFunction) {
    return clusteredFunction;
  }
  var styles = {
    typed: mapmodule.getGeomTypedStyles(DEFAULT_STYLES.style),
    optional: []
  };
  defaultStyleFunction = getStyleFunction(styles);
  if (isClustered) {
    clusteredFunction = wrapClusterStyleFunction(defaultStyleFunction);
    return clusteredFunction;
  }
  return defaultStyleFunction;
};
export var styleGenerator = function styleGenerator(mapmodule, layer) {
  if (!layer) {
    return getDefaultStyleFunction(mapmodule);
  }
  // 3D doesn't support cluster and layer opacity is applied to style
  // Don't use default styles or cluster
  if (mapmodule.getSupports3D()) {
    return mapmodule.getStyleForLayer(layer);
  }
  var style = layer.getCurrentStyle();
  if (!style || !style.hasDefinitions()) {
    return defaultStyleGenerator(mapmodule, layer);
  }
  var styleFunction = mapmodule.getStyleForLayer(layer);
  if (isClusteredLayer(mapmodule, layer)) {
    return wrapClusterStyleFunction(styleFunction);
  }
  return styleFunction;
};